import React, { useState } from 'react';
import { ErrorMarker, DeleteIcon } from 'assets/icons';
import { useDispatch } from 'react-redux';
import { applicationActions } from 'store/application';
import PropTypes from 'prop-types';
import * as S from './Upload.styled';
import { creativesActions } from 'store/campaign/creatives';
import { MODELSTATES, BUTTON_LABELS } from 'constants';

export const sizes = {
  Big: 'Big',
  Medium: 'Medium',
  Normal: 'Normal',
  Icon: 'Icon',
};

const Upload = React.memo(
  ({ id, name, value, size, accept = 'image/*', error = false, errorText, onChange, fileType }) => {
    const [file, setFile] = useState(null);

    const dispatch = useDispatch();
    let link = value ? `https://cdn.appnext.com/apps/${value}` : null;

    const [preview, setPreview] = useState(link);

    const openCreativePrompt = () => {
      dispatch(creativesActions.changePromptState(MODELSTATES.EMPTY));
      dispatch(applicationActions.setCreativeModalType(`${fileType}`));
      dispatch(creativesActions.changePromptLabel(BUTTON_LABELS.USEDATCREATIVE));
      dispatch(applicationActions.openNewCreativeModal());
    };

    const deleteFile = () => {
      setFile(null);
      setPreview(null);
      onChange(null);
    };

    const Content = () => {
      if (file || preview) {
        return (
          <S.Output size={size}>
            <S.ImageWrapper size={size}>
              <img alt='' src={preview} />
            </S.ImageWrapper>
            <S.DeleteBtn type='button' onClick={deleteFile}>
              <DeleteIcon />
            </S.DeleteBtn>
          </S.Output>
        );
      } else {
        return (
          <>
            <S.UploadBtn component='label'>
              <span style={{ textTransform: 'none' }}>Choose File</span>
              <input onClick={openCreativePrompt} accept={accept} hidden />
            </S.UploadBtn>
          </>
        );
      }
    };

    return (
      <S.Container id={id} name={name} size={size}>
        <S.UploadWrapper isEmpty={!file} error={error} size={size}>
          <Content />
        </S.UploadWrapper>
        {error && (
          <S.ErrorWrapper>
            <ErrorMarker />
            <S.ErrorText>{errorText}</S.ErrorText>
          </S.ErrorWrapper>
        )}
      </S.Container>
    );
  },
);

Upload.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.string.isRequired,
  accept: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  defaultLink: PropTypes.string,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  limit: PropTypes.number,
};

Upload.displayName = 'Upload';

export default Upload;
